import React from 'react';
import * as queryParser from 'query-string'

const useQueryParams = (queryString) => {
  return queryParser.parse(queryString)
}

export default useQueryParams;